import { sendDelete, sendGet, sendPost, uploadFile } from "./generic"

export const getEndorsements = () => {
    return sendGet(`Admin/Endorsements`)
}

export const getEndorsement = (id) => {
    return sendGet(`Admin/Endorsements/${id}`)
}

export const addEndorsement = (payload) => {
    return sendPost(`Admin/Endorsements`, payload)
}

export const editEndorsement = (payload) => {
    return sendPost(`Admin/Endorsements`, payload)
}

export const deleteEndorsement = (id) => {
    return sendDelete(`Admin/Endorsements/${id}`)
}

export const reorderEndorsements = (payload) => {
    return sendPost(`Admin/Endorsements/Reorder`, payload)
}

export const addEndorsementFile = (payload) => {
    return uploadFile("Admin/EndorsementFiles", payload)
}

export const deleteEndorsementFile = (id) => {
    return sendDelete(`Admin/EndorsementFiles/${id}`)
}
